

import * as THREE from 'three';



export default class Dust {

	init = function( scene, dustObject, texture )
	{

  	let uniforms = {

     	diffuseMap: { value: texture },
     	posScale: { value: 1.0 },
     	customSize: { value: 1.0 },
      time: { type:"f", value:0.1 }

    };	

    let shaderMaterial = new THREE.ShaderMaterial( {

      uniforms: uniforms,
      vertexShader:   `
          
          attribute float size;

          uniform float time;
          uniform float posScale;
          uniform float customSize;
          varying vec3 vColor;
          varying float eAlpha;
          varying float pAlpha;

          void main() {

            vColor = color;

            vec3 nposition  = position * posScale;
            vec4 mvPosition = modelViewMatrix * vec4( nposition, 1.0 );

            gl_PointSize = size * ( 300.0 / -mvPosition.z ) * customSize;
            gl_Position = projectionMatrix * mvPosition;

          }
      `,
      fragmentShader:  `
          
          uniform sampler2D diffuseMap;

          varying vec3 vColor;
          varying float eAlpha;
          varying float pAlpha;

          void main() {

            //if( eAlpha > 0.2 ) gl_FragColor   = vec4( vColor, eAlpha );
            //if( eAlpha > 0.2 ) gl_FragColor   = vec4( vColor, eAlpha );

            gl_FragColor   = texture2D( diffuseMap, gl_PointCoord );

          }
      `,

      depthTest:      false,
      transparent:    true,
      vertexColors:   true,
      blending: THREE.AdditiveBlending

    });

    shaderMaterial.uniforms["diffuseMap"].value = texture;
    shaderMaterial.uniforms["customSize"].value = 2.0;
    
    this.geometry = new THREE.BufferGeometry();

    let positions = [];
    let speed     = [];
    let colors    = [];
    let sizes     = [];
    this.scale    = [];

    let color     = new THREE.Color( 1.0, 1.0, 1.0);

    for ( let i = 0; i < 1000; i+=3 ) {
          
          positions.push( -15 + Math.random() * 30, -5.6 + Math.random() * 10, -15 + Math.random() * 30 );
          speed.push( (-0.05 + Math.random() * 1.0 ) * Math.random() * 0.01, (-0.05 + Math.random() * 1.0 ) * Math.random() * 0.01, (-1.05 + Math.random() * 2.0 ) * Math.random() * 0.05 );
          colors.push( color.r, color.g, color.b );
          sizes.push( 0.1 );
          this.scale.push( [ -.25 + Math.random() * 1.0, Math.random() * 0.0008 ] );

    }


    this.geometry.addAttribute( 'position', new THREE.Float32BufferAttribute( positions, 3 ).setDynamic( true ) );  
    this.geometry.addAttribute( 'speed', new THREE.Float32BufferAttribute( speed, 3 ).setDynamic( true ) );        
    this.geometry.addAttribute( 'color', new THREE.Float32BufferAttribute( colors, 3 ) );
    this.geometry.addAttribute( 'size', new THREE.Float32BufferAttribute( sizes, 1 ).setDynamic( true ) );      

		this.dust = new THREE.Points( this.geometry, shaderMaterial );

		this.spriteBase = new THREE.Object3D();
		this.sprites    = [];        	

	  dustObject.add( this.spriteBase );
	  this.spriteBase.add( this.dust ); 

	}


	renderDust = function( t, camera ) {

    	this.spriteBase.rotation.y += 0.0007;
      //this.spriteBase.position.y  = -2 + Math.sin( t * 0.00009 ) * 4;


      let attributes = this.dust.geometry.attributes;
      var k = 0;

      for ( let u = 0; u < attributes.position.array.length; u += 3) {
      		   
             var p = new THREE.Vector3(
                       
                      attributes.position.array[u],
                      attributes.position.array[u + 1],
                      attributes.position.array[u + 2]
              );


              attributes.position.array[ u ]     = p.x + attributes.speed.array[ u ];
              attributes.position.array[ u + 1 ] = p.y + attributes.speed.array[ u + 1 ];
              attributes.position.array[ u + 2 ] = p.z + attributes.speed.array[ u + 2 ];


              if( attributes.position.array[ u ] >  14.5 ) attributes.position.array[ u ] = -14.495;
              if( attributes.position.array[ u ] < -14.5 ) attributes.position.array[ u ] =  14.495;

              if( attributes.position.array[ u + 1 ] >  9.5 ) attributes.position.array[ u + 1 ] = -5.495;
              if( attributes.position.array[ u + 1 ] < -5.5 ) attributes.position.array[ u + 1 ] =  9.495;

              if( attributes.position.array[ u + 2 ] >  14.5 ) attributes.position.array[ u + 2 ] = -14.495;
              if( attributes.position.array[ u + 2 ] < -14.5 ) attributes.position.array[ u + 2 ] =  14.495;      


              let getSize = attributes.size.array[k];

              if( this.scale[k][0] > 0 && getSize < 0.45 ) {

                  getSize += this.scale[k][1];
                  attributes.size.array[k] = getSize;

              } else {

                  this.scale[k][0] = -1;

              }

              if( this.scale[k][0] < 0 && getSize > 0.001 ) {

                  getSize -= this.scale[k][1];
                  attributes.size.array[k] = getSize;

              } else {

                  this.scale[k][0] = 1;
                  
              }              
      
              k++;

      }

      attributes.position.needsUpdate = true;
      attributes.size.needsUpdate = true;


      this.spriteBase.quaternion.copy( camera.quaternion );

	}

}
